export default __webpack_public_path__ + "static/media/logo-integravisionIA.b81bf751.png";